import script from "./ModalData.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalData.vue?vue&type=script&setup=true&lang=js"

import "./ModalData.vue?vue&type=style&index=0&id=05943aca&lang=css"

const __exports__ = script;

export default __exports__